
const mock = [
  'Autoria',
  'Autor',
  'autor desconhecido',
  'Pseudônimo',
  'Anônimo',
  'Criador',
  'Originador',
  'Coautoria',
  'Colaborador',
  'Diretor',
  'Titular',
  'Pessoa jurídica',
  'Titular originário',
  'Organizador',
  'Editor',
  'Coordenador',
  'sucessores/herdeiros',
  'Obra protegida',
  'Expressão',
  'Fixação',
  'Registro',
  'originalidade',
  'criatividade',
  'Exclusão de proteção',
  'ideias',
  'procedimentos normativos',
  'sistemas',
  'métodos',
  'projetos',
  'conceitos matemáticos como tais;',
  'esquemas',
  'planos',
  'regras para realizar atos mentais, jogos ou negócios',
  'formulários',
  'textos de tratados',
  'convenções',
  'leis',
  'decretos',
  'regulamentos',
  'decisões judiciais',
  'atos oficiais',
  'informações de uso comum tais como calendários, agendas, cadastros ou legendas;',
  'os nomes e títulos isolados;',
  'o aproveitamento industrial ou comercial das idéias contidas nas obras.',
  'Contratos',
  'Licença',
  'Concessão',
  'Cessão',
  'Autorização',
  'Domínio Público',
  'Registro',
  'INPI',
  'Biblioteca Nacional',
  'Escola de Música',
  'Escola de Belas Artes da Universidade Federal do Rio de Janeiro',
  'Instituto Nacional do Cinema',
  'Conselho Federal de Engenharia, Arquitetura e Agronomia',
  'CREA',
  'CAU',
  'Limitações',
  'pessoas com deficiência',
  'pequenos trechos',
  'uso privado',
  'notícia',
  'artigo informativo',
  'citação',
  'crítica',
  'polêmica',
  'estudo',
  'lições',
  'ensino',
  'uso didático',
  'demonstração',
  'recesso familiar',
  'uso não comercial',
  'uso sem intuito de lucro',
  'prova judiciária',
  'prova administrativa',
  'exploração normal da obra',
  'prejuízo injustificado aos legítimos interesses dos autores',
  'paráfrases',
  'paródias',
  'obras em logradouros públicos',
  'Obra Protegida',
  'Obra intelectual',
  'Obra coletiva',
  'Obra audiovisual',
  'Obra derivada',
  'Obra originária',
  'Obra póstuma',
  'Obra inédita',
  'Obra pseudônima',
  'Obra anônima',
  'Obra em co-autoria',
  'Obra literária',
  'Obra artística',
  'obra de arte plástica',
  'Obra científica',
  'conferências',
  'alocuções',
  'sermões',
  'obras dramáticas',
  'obras dramático-musicais',
  'obras coreográficas',
  'obras pantomímicas',
  'composições musicais',
  'obras cinematográficas',
  'obras fotográficas',
  'desenho',
  'pintura',
  'gravura',
  'escultura',
  'litografia',
  'arte cinética',
  'ilustrações',
  'cartas geográficas ',
  'retratos',
  'projetos',
  'geografia',
  'engenharia',
  'topografia',
  'arquitetura',
  'paisagismo',
  'cenografia',
  'ciência',
  'esboços',
  'geografia',
  'engenharia',
  'topografia',
  'arquitetura',
  'paisagismo',
  'cenografia',
  'ciência',
  'obras plásticas',
  'geografia',
  'engenharia',
  'topografia',
  'arquitetura',
  'paisagismo',
  'cenografia',
  'ciência',
  'adaptações',
  'traduções',
  'transformações ',
  'programas de computador',
  'coletâneas',
  'compilações',
  'antologias',
  'enciclopédias',
  'dicionários',
  'publicações periódicas',
  'cartas missivas',
  'bases de dados',
  'seleção',
  'organização',
  'disposição ',
  'Direitos Conexos',
  'Intérprete',
  'Artista intérprete',
  'Artista',
  'Executante',
  'Músico',
  'Radiodifusão',
  'Produtor',
  'Dublador',
  'fixação',
  'interpretação',
  'execução',
  'locação',
  'voz e imagem',
  'fonograma',
  'Programas de Computador',
  'Software',
  'Código-Fonte',
  'Código-Objeto',
  'linguagem natural',
  'linguagem codificada',
  'máquinas automáticas de tratamento de informação',
  'descrição funcional',
  'salvaguarda',
  'armazenamento eletrônico',
  'citação',
  'fins didáticos',
  'semelhança funcional',
  'preceitos normativos e técnicos',
  'limitação de forma alternativa para expressão',
  'integração de um programa a um sistema aplicativo ou operacional',
  'interoperabilidade',
  'contrato de licença de uso',
  'garantias aos usuários',
  'transferência de tecnologia',
  'tributação',
  'Sanções Civis e penais',
  'Contrafação',
  'reprodução fraudulenta',
  'edição fraudulenta',
  'apreensão de exemplares',
  'suspensão de divulgação',
  'indenização',
  'violação',
  'sanção civil',
  'sanção penal',
  'multa',
  'sentença condenatória',
  'exemplares ilícitos',
  'perda de máquinas, equipamentos e insumos',
  'destruição de máquinas, equipamentos e insumos',
  'perdas e danos',
  'alteração, supressão, modificação ou inutilização de dispositivos técnicos;',
  'alteração, supressão, modificação ou inutilização de sinais codificados;',
  'alteração, supressão, modificação ou inutilização de informações sobre gestão de direitos;',
  'Direitos Morais',
  'Paternidade',
  'Comunicação',
  'Inédito',
  'Retirada',
  'Integridade',
  'Modificação',
  'Acesso a exemplar raro',
  'Inalienável',
  'Irrenunciável',
  'Direito de Sequência',
  'Direitos Patrimoniais',
  'Edição',
  'Publicação',
  'Transmissão',
  'Emissão',
  'Retransmissão',
  'Distribuição',
  'Comunicação ao público',
  'Reprodução',
  'Adaptação',
  'arranjo musical',
  'tradução ',
  'inclusão em fonograma',
  'produção audiovisual',
  'utilização',
  'representação',
  'recitação',
  'declamação',
  'execução musical',
  'emprego de alto-falante ',
  'radiodifusão sonora ',
  'radiodifusão televisiva',
  'captação de transmissão de radiodifusão',
  'sonorização ambiental',
  'exibição audiovisual',
  'exibição cinematográfica ',
  'emprego de satélites artificiais',
  'emprego de sistemas óticos',
  'fios telefônicos',
  'cabos de qualquer tipo',
  'meios de comunicação ',
  'exposição de obras de artes plásticas e figurativas',
  'inclusão em base de dados',
  'armazenamento em computador',
  'microfilmagem',
  'arquivamento',
  'Contratos',
  'transferência',
  'cessão',
  'concessão',
  'licenciamento',
  'licença',
  'autorização',
  'prazo máximo',
  'território',
  'objeto',
  'modalidade de utilização',
  'onerosa',
  'gratuita',
  'Comunicação ao público',
  'ECAD',
  'escritório central',
  'associação',
  'gestão coletiva',
  'prestação de contas',
  'arrecadação',
  'distribuição',
  'representação',
  'empresário',
  'execução pública',
  'frequência coletiva',
  'teatros',
  'cinemas',
  'salões de baile ou concertos',
  'concertos',
  'boates',
  'bares',
  'clubes ou associações de qualquer natureza',
  'lojas',
  'estabelecimentos comerciais e industriais',
  'estádios',
  'circos',
  'feiras',
  'restaurantes',
  'hotéis',
  'motéis',
  'clínicas',
  'hospitais',
  'Órgãos públicos da administração direta ou indireta, fundacionais e estatais ',
  'Meios de transporte de passageiros terrestre, marítimo, fluvial ou aéreo',
  'D. Penal e Penal',
  'D. Administrativo',
  'Sindicatos',
  'Direito Civil',
  'Direito do Trabalho',
  'Direitos de Personalidade',
  'D. Processual Civil',
  'D. Tributário',
  'Propriedade Intelectual',
  'Responsabilidade Civil',
  'Processo legislativo',
  'Política(s) pública(s)',
  'OMPI',
  'Tratados internacionais',
  'Políticas culturais ',
  'Processo civil',
  'Processo penal',
  'Enunciados',
  'Constituição Federal'
];

const indices = [
  {
      "label": "D. Administrativo",
      "value": "D. Administrativo"
  },
  {
      "label": "Autoria",
      "value": "Autoria",
      "children": [
          {
              "label": "Autor",
              "value": "Autor"
          },
          {
              "label": "autor desconhecido",
              "value": "autor desconhecido"
          },
          {
              "label": "Pseudônimo",
              "value": "Pseudônimo"
          },
          {
              "label": "Anônimo",
              "value": "Anônimo"
          },
          {
              "label": "Criador",
              "value": "Criador"
          },
          {
              "label": "Originador",
              "value": "Originador"
          },
          {
              "label": "Co-autoria",
              "value": "Co-autoria"
          },
          {
              "label": "Colaborador",
              "value": "Colaborador"
          },
          {
              "label": "Diretor",
              "value": "Diretor"
          }
      ]
  },
  {
      "label": "Titular",
      "value": "Titular",
      "children": [
          {
              "label": "Pessoa jurídica",
              "value": "Pessoa jurídica"
          },
          {
              "label": "Titular originário",
              "value": "Titular originário"
          },
          {
              "label": "Organizador",
              "value": "Organizador"
          },
          {
              "label": "Editor",
              "value": "Editor"
          },
          {
              "label": "Coordenador",
              "value": "Coordenador"
          },
          {
              "label": "sucessores/herdeiros",
              "value": "sucessores/herdeiros"
          }
      ]
  },
  {
      "label": "Obra protegida",
      "value": "Obra protegida",
      "children": [
          {
              "label": "Expressão",
              "value": "Expressão"
          },
          {
              "label": "Fixação",
              "value": "Fixação"
          },
          {
              "label": "Registro",
              "value": "Registro"
          },
          {
              "label": "originalidade",
              "value": "originalidade"
          },
          {
              "label": "criatividade",
              "value": "criatividade"
          }
      ]
  },
  {
      "label": "Exclusão de proteção",
      "value": "Exclusão de proteção",
      "children": [
          {
              "label": "idéias",
              "value": "idéias"
          },
          {
              "label": "procedimentos normativos",
              "value": "procedimentos normativos"
          },
          {
              "label": "sistemas",
              "value": "sistemas"
          },
          {
              "label": "métodos",
              "value": "métodos"
          },
          {
              "label": "projetos",
              "value": "projetos"
          },
          {
              "label": "conceitos matemáticos como tais;",
              "value": "conceitos matemáticos como tais;"
          },
          {
              "label": "esquemas",
              "value": "esquemas"
          },
          {
              "label": "planos",
              "value": "planos"
          },
          {
              "label": "regras para realizar atos mentais, jogos ou negócios",
              "value": "regras para realizar atos mentais, jogos ou negócios"
          },
          {
              "label": "formulários",
              "value": "formulários"
          },
          {
              "label": "textos de tratados",
              "value": "textos de tratados"
          },
          {
              "label": "convenções",
              "value": "convenções"
          },
          {
              "label": "leis",
              "value": "leis"
          },
          {
              "label": "decretos",
              "value": "decretos"
          },
          {
              "label": "regulamentos",
              "value": "regulamentos"
          },
          {
              "label": "decisões judiciais",
              "value": "decisões judiciais"
          },
          {
              "label": "atos oficiais",
              "value": "atos oficiais"
          },
          {
              "label": "informações de uso comum tais como calendários, agendas, cadastros ou legendas;",
              "value": "informações de uso comum tais como calendários, agendas, cadastros ou legendas;"
          },
          {
              "label": "os nomes e títulos isolados;",
              "value": "os nomes e títulos isolados;"
          },
          {
              "label": "o aproveitamento industrial ou comercial das idéias contidas nas obras",
              "value": "o aproveitamento industrial ou comercial das idéias contidas nas obras"
          }
      ]
  },
  {
      "label": "Contratos",
      "value": "Contratos",
      "children": [
          {
              "label": "Licença",
              "value": "Licença"
          },
          {
              "label": "Concessão",
              "value": "Concessão"
          },
          {
              "label": "Cessão",
              "value": "Cessão"
          },
          {
              "label": "Autorização",
              "value": "Autorização"
          }
      ]
  },
  {
      "label": "Domínio Público",
      "value": "Domínio Público"
  },
  {
      "label": "Registro",
      "value": "Registro",
      "children": [
          {
              "label": "INPI",
              "value": "INPI"
          },
          {
              "label": "Biblioteca Nacional",
              "value": "Biblioteca Nacional"
          },
          {
              "label": "Escola de Música",
              "value": "Escola de Música"
          },
          {
              "label": "Escola de Belas Artes da Universidade Federal do Rio de Janeiro",
              "value": "Escola de Belas Artes da Universidade Federal do Rio de Janeiro"
          },
          {
              "label": "Instituto Nacional do Cinema,",
              "value": "Instituto Nacional do Cinema,"
          },
          {
              "label": "Conselho Federal de Engenharia, Arquitetura e Agronomia",
              "value": "Conselho Federal de Engenharia, Arquitetura e Agronomia"
          },
          {
              "label": "CREA",
              "value": "CREA"
          },
          {
              "label": "CAU",
              "value": "CAU"
          }
      ]
  },
  {
      "label": "Limitações",
      "value": "Limitações",
      "children": [
          {
              "label": "pessoas com deficiência",
              "value": "pessoas com deficiência"
          },
          {
              "label": "pequenos trechos",
              "value": "pequenos trechos"
          },
          {
              "label": "uso privado",
              "value": "uso privado"
          },
          {
              "label": "notícia",
              "value": "notícia"
          },
          {
              "label": "artigo informativo",
              "value": "artigo informativo"
          },
          {
              "label": "citação",
              "value": "citação"
          },
          {
              "label": "crítica",
              "value": "crítica"
          },
          {
              "label": "polêmica",
              "value": "polêmica"
          },
          {
              "label": "estudo",
              "value": "estudo"
          },
          {
              "label": "lições",
              "value": "lições"
          },
          {
              "label": "ensino",
              "value": "ensino"
          },
          {
              "label": "uso didático",
              "value": "uso didático"
          },
          {
              "label": "demonstração",
              "value": "demonstração"
          },
          {
              "label": "recesso familiar",
              "value": "recesso familiar"
          },
          {
              "label": "uso não comercial",
              "value": "uso não comercial"
          },
          {
              "label": "uso sem intuito de lucro",
              "value": "uso sem intuito de lucro"
          },
          {
              "label": "prova judiciária",
              "value": "prova judiciária"
          },
          {
              "label": "prova administrativa",
              "value": "prova administrativa"
          },
          {
              "label": "exploração normal da obra",
              "value": "exploração normal da obra"
          },
          {
              "label": "prejuízo injustificado aos legítimos interesses dos autores",
              "value": "prejuízo injustificado aos legítimos interesses dos autores"
          },
          {
              "label": "paráfrases",
              "value": "paráfrases"
          },
          {
              "label": "paródias",
              "value": "paródias"
          },
          {
              "label": "obras em logradouros públicos",
              "value": "obras em logradouros públicos"
          }
      ]
  },
  {
      "label": "Obra Protegida",
      "value": "Obra Protegida",
      "children": [
          {
              "label": "Obra intelectual",
              "value": "Obra intelectual"
          },
          {
              "label": "Obra coletiva",
              "value": "Obra coletiva"
          },
          {
              "label": "Obra audiovisual",
              "value": "Obra audiovisual"
          },
          {
              "label": "Obra derivada",
              "value": "Obra derivada"
          },
          {
              "label": "Obra originária",
              "value": "Obra originária"
          },
          {
              "label": "Obra póstuma",
              "value": "Obra póstuma"
          },
          {
              "label": "Obra inédita",
              "value": "Obra inédita"
          },
          {
              "label": "Obra pseudônima",
              "value": "Obra pseudônima"
          },
          {
              "label": "Obra anônima",
              "value": "Obra anônima"
          },
          {
              "label": "Obra em co-autoria",
              "value": "Obra em co-autoria"
          },
          {
              "label": "Obra literária",
              "value": "Obra literária"
          },
          {
              "label": "Obra artística",
              "value": "Obra artística"
          },
          {
              "label": "obra de arte plástica",
              "value": "obra de arte plástica"
          },
          {
              "label": "Obra científica",
              "value": "Obra científica"
          },
          {
              "label": "conferências",
              "value": "conferências"
          },
          {
              "label": "alocuções",
              "value": "alocuções"
          },
          {
              "label": "sermões",
              "value": "sermões"
          },
          {
              "label": "obras dramáticas",
              "value": "obras dramáticas"
          },
          {
              "label": "obras dramático-musicais",
              "value": "obras dramático-musicais"
          },
          {
              "label": "obras coreográficas",
              "value": "obras coreográficas"
          },
          {
              "label": "obras pantomímicas",
              "value": "obras pantomímicas"
          },
          {
              "label": "composições musicais",
              "value": "composições musicais"
          },
          {
              "label": "obras cinematográficas",
              "value": "obras cinematográficas"
          },
          {
              "label": "obras fotográficas",
              "value": "obras fotográficas"
          },
          {
              "label": "desenho",
              "value": "desenho"
          },
          {
              "label": "pintura",
              "value": "pintura"
          },
          {
              "label": "gravura",
              "value": "gravura"
          },
          {
              "label": "escultura",
              "value": "escultura"
          },
          {
              "label": "litografia",
              "value": "litografia"
          },
          {
              "label": "arte cinética",
              "value": "arte cinética"
          },
          {
              "label": "ilustrações",
              "value": "ilustrações"
          },
          {
              "label": "cartas geográficas",
              "value": "cartas geográficas"
          },
          {
              "label": "retratos",
              "value": "retratos"
          },
          {
              "label": "projetos",
              "value": "projetos",
              "children": [
                  {
                      "label": "geografia",
                      "value": "geografia"
                  },
                  {
                      "label": "engenharia",
                      "value": "engenharia"
                  },
                  {
                      "label": "topografia",
                      "value": "topografia"
                  },
                  {
                      "label": "arquitetura",
                      "value": "arquitetura"
                  },
                  {
                      "label": "paisagismo",
                      "value": "paisagismo"
                  },
                  {
                      "label": "cenografia",
                      "value": "cenografia"
                  },
                  {
                      "label": "ciência",
                      "value": "ciência"
                  }
              ]
          },
          {
              "label": "esboços",
              "value": "esboços",
              "children": [
                  {
                      "label": "geografia",
                      "value": "geografia"
                  },
                  {
                      "label": "engenharia",
                      "value": "engenharia"
                  },
                  {
                      "label": "topografia",
                      "value": "topografia"
                  },
                  {
                      "label": "arquitetura",
                      "value": "arquitetura"
                  },
                  {
                      "label": "paisagismo",
                      "value": "paisagismo"
                  },
                  {
                      "label": "cenografia",
                      "value": "cenografia"
                  },
                  {
                      "label": "ciência",
                      "value": "ciência"
                  }
              ]
          },
          {
              "label": "obras plásticas",
              "value": "obras plásticas",
              "children": [
                  {
                      "label": "geografia",
                      "value": "geografia"
                  },
                  {
                      "label": "engenharia",
                      "value": "engenharia"
                  },
                  {
                      "label": "topografia",
                      "value": "topografia"
                  },
                  {
                      "label": "arquitetura",
                      "value": "arquitetura"
                  },
                  {
                      "label": "paisagismo",
                      "value": "paisagismo"
                  },
                  {
                      "label": "cenografia",
                      "value": "cenografia"
                  },
                  {
                      "label": "ciência",
                      "value": "ciência"
                  }
              ]
          },
          {
              "label": "adaptações",
              "value": "adaptações"
          },
          {
              "label": "traduções",
              "value": "traduções"
          },
          {
              "label": "transformações",
              "value": "transformações"
          },
          {
              "label": "programas de computador",
              "value": "programas de computador"
          },
          {
              "label": "coletâneas",
              "value": "coletâneas"
          },
          {
              "label": "compilações",
              "value": "compilações"
          },
          {
              "label": "antologias",
              "value": "antologias"
          },
          {
              "label": "enciclopédias",
              "value": "enciclopédias"
          },
          {
              "label": "dicionários",
              "value": "dicionários"
          },
          {
              "label": "publicações periódicas",
              "value": "publicações periódicas"
          },
          {
              "label": "cartas missivas",
              "value": "cartas missivas"
          },
          {
              "label": "bases de dados",
              "value": "bases de dados",
              "children": [
                  {
                      "label": "seleção",
                      "value": "seleção"
                  },
                  {
                      "label": "organização",
                      "value": "organização"
                  },
                  {
                      "label": "disposição",
                      "value": "disposição"
                  }
              ]
          }
      ]
  },
  {
      "label": "Direitos Conexos",
      "value": "Direitos Conexos",
      "children": [
          {
              "label": "Intérprete",
              "value": "Intérprete"
          },
          {
              "label": "Artista intérprete",
              "value": "Artista intérprete"
          },
          {
              "label": "Executante",
              "value": "Executante"
          },
          {
              "label": "Músico",
              "value": "Músico"
          },
          {
              "label": "Radiodifusão",
              "value": "Radiodifusão"
          },
          {
              "label": "Produtor",
              "value": "Produtor"
          },
          {
              "label": "Dublador",
              "value": "Dublador"
          },
          {
              "label": "fixação",
              "value": "fixação"
          },
          {
              "label": "interpretação",
              "value": "interpretação"
          },
          {
              "label": "execução",
              "value": "execução"
          },
          {
              "label": "locação",
              "value": "locação"
          },
          {
              "label": "voz e imagem",
              "value": "voz e imagem"
          }
      ]
  },
  {
      "label": "Programas de Computador",
      "value": "Programas de Computador",
      "children": [
          {
              "label": "Software",
              "value": "Software"
          },
          {
              "label": "Código-Fonte",
              "value": "Código-Fonte"
          },
          {
              "label": "Codigo-Objeto",
              "value": "Codigo-Objeto"
          },
          {
              "label": "linguagem natural",
              "value": "linguagem natural"
          },
          {
              "label": "linguagem codificada",
              "value": "linguagem codificada"
          },
          {
              "label": "máquinas automáticas de tratamento de informação",
              "value": "máquinas automáticas de tratamento de informação"
          },
          {
              "label": "descrição funcional",
              "value": "descrição funcional"
          },
          {
              "label": "salvaguarda",
              "value": "salvaguarda"
          },
          {
              "label": "armazenamento eletrônico",
              "value": "armazenamento eletrônico"
          },
          {
              "label": "citação",
              "value": "citação"
          },
          {
              "label": "fins didáticos",
              "value": "fins didáticos"
          },
          {
              "label": "semelhança funcional",
              "value": "semelhança funcional"
          },
          {
              "label": "preceitos normativos e técnicos",
              "value": "preceitos normativos e técnicos"
          },
          {
              "label": "limitação de forma alternativa para expressão",
              "value": "limitação de forma alternativa para expressão"
          },
          {
              "label": "integração de um programa a um sistema aplicativo ou operacional",
              "value": "integração de um programa a um sistema aplicativo ou operacional"
          },
          {
              "label": "interoperabilidade",
              "value": "interoperabilidade"
          },
          {
              "label": "contrato de licença de uso",
              "value": "contrato de licença de uso"
          },
          {
              "label": "garantias aos usuários",
              "value": "garantias aos usuários"
          },
          {
              "label": "transferência de tecnologia",
              "value": "transferência de tecnologia"
          },
          {
              "label": "tributação",
              "value": "tributação"
          }
      ]
  },
  {
      "label": "Sanções Civis e penais",
      "value": "Sanções Civis e penais",
      "children": [
          {
              "label": "Contrafação",
              "value": "Contrafação"
          },
          {
              "label": "reprodução fraudulenta",
              "value": "reprodução fraudulenta"
          },
          {
              "label": "edição fraudulenta",
              "value": "edição fraudulenta"
          },
          {
              "label": "apreensão de exemplares",
              "value": "apreensão de exemplares"
          },
          {
              "label": "suspensão de divulgação",
              "value": "suspensão de divulgação"
          },
          {
              "label": "indenização",
              "value": "indenização"
          },
          {
              "label": "violação",
              "value": "violação"
          },
          {
              "label": "sanção civil",
              "value": "sanção civil"
          },
          {
              "label": "sanção penal",
              "value": "sanção penal"
          },
          {
              "label": "multa",
              "value": "multa"
          },
          {
              "label": "sentença condenatória",
              "value": "sentença condenatória"
          },
          {
              "label": "exemplares ilícitos",
              "value": "exemplares ilícitos"
          },
          {
              "label": "perda de máquinas, equipamentos e insumos",
              "value": "perda de máquinas, equipamentos e insumos"
          },
          {
              "label": "destruição de máquinas, equipamentos e insumos",
              "value": "destruição de máquinas, equipamentos e insumos"
          },
          {
              "label": "perdas e danos",
              "value": "perdas e danos"
          },
          {
              "label": "alteração, supressão, modificação ou inutilização de dispositivos técnicos;",
              "value": "alteração, supressão, modificação ou inutilização de dispositivos técnicos;"
          },
          {
              "label": "alteração, supressão, modificação ou inutilização de sinais codificados;",
              "value": "alteração, supressão, modificação ou inutilização de sinais codificados;"
          },
          {
              "label": "alteração, supressão, modificação ou inutilização de informações sobre gestão de direitos;",
              "value": "alteração, supressão, modificação ou inutilização de informações sobre gestão de direitos;"
          }
      ]
  },
  {
      "label": "Direitos Morais",
      "value": "Direitos Morais",
      "children": [
          {
              "label": "Paternidade",
              "value": "Paternidade"
          },
          {
              "label": "Comunicação",
              "value": "Comunicação"
          },
          {
              "label": "Inédito",
              "value": "Inédito"
          },
          {
              "label": "Retirada",
              "value": "Retirada"
          },
          {
              "label": "Integridade",
              "value": "Integridade"
          },
          {
              "label": "Modificação",
              "value": "Modificação"
          },
          {
              "label": "Acesso a exemplar raro",
              "value": "Acesso a exemplar raro"
          },
          {
              "label": "Inalienável",
              "value": "Inalienável"
          },
          {
              "label": "Irrenunciável",
              "value": "Irrenunciável"
          }
      ]
  },
  {
      "label": "Direito de Sequência",
      "value": "Direito de Sequência"
  },
  {
      "label": "Direitos Patrimoniais",
      "value": "Direitos Patrimoniais",
      "children": [
          {
              "label": "Edição",
              "value": "Edição"
          },
          {
              "label": "Publicação",
              "value": "Publicação"
          },
          {
              "label": "Transmissão",
              "value": "Transmissão"
          },
          {
              "label": "Emissão",
              "value": "Emissão"
          },
          {
              "label": "Retransmissão",
              "value": "Retransmissão"
          },
          {
              "label": "Distribuição",
              "value": "Distribuição"
          },
          {
              "label": "Comunicação ao público",
              "value": "Comunicação ao público"
          },
          {
              "label": "Reprodução",
              "value": "Reprodução"
          },
          {
              "label": "Adaptação",
              "value": "Adaptação"
          },
          {
              "label": "arranjo musical",
              "value": "arranjo musical"
          },
          {
              "label": "tradução",
              "value": "tradução"
          },
          {
              "label": "inclusão em fonograma",
              "value": "inclusão em fonograma"
          },
          {
              "label": "produção audiovisual",
              "value": "produção audiovisual"
          },
          {
              "label": "utilização",
              "value": "utilização"
          },
          {
              "label": "representação",
              "value": "representação"
          },
          {
              "label": "recitação",
              "value": "recitação"
          },
          {
              "label": "declamação",
              "value": "declamação"
          },
          {
              "label": "execução musical",
              "value": "execução musical"
          },
          {
              "label": "emprego de alto-falante",
              "value": "emprego de alto-falante"
          },
          {
              "label": "radiodifusão sonora",
              "value": "radiodifusão sonora"
          },
          {
              "label": "radiodifusão televisiva",
              "value": "radiodifusão televisiva"
          },
          {
              "label": "captação de transmissão de radiodifusão",
              "value": "captação de transmissão de radiodifusão"
          },
          {
              "label": "sonorização ambiental",
              "value": "sonorização ambiental"
          },
          {
              "label": "exibição audiovisual",
              "value": "exibição audiovisual"
          },
          {
              "label": "exibição cinematográfica",
              "value": "exibição cinematográfica"
          },
          {
              "label": "emprego de satélites artificiais",
              "value": "emprego de satélites artificiais"
          },
          {
              "label": "emprego de sistemas óticos",
              "value": "emprego de sistemas óticos"
          },
          {
              "label": "fios telefônicos",
              "value": "fios telefônicos"
          },
          {
              "label": "cabos de qualquer tipo",
              "value": "cabos de qualquer tipo"
          },
          {
              "label": "meios de comunicação",
              "value": "meios de comunicação"
          },
          {
              "label": "exposição de obras de artes plásticas e figurativas",
              "value": "exposição de obras de artes plásticas e figurativas"
          },
          {
              "label": "inclusão em base de dados",
              "value": "inclusão em base de dados"
          },
          {
              "label": "armazenamento em computador",
              "value": "armazenamento em computador"
          },
          {
              "label": "microfilmagem",
              "value": "microfilmagem"
          },
          {
              "label": "arquivamento",
              "value": "arquivamento"
          }
      ]
  },
  {
      "label": "Contratos",
      "value": "Contratos",
      "children": [
          {
              "label": "transferência",
              "value": "transferência"
          },
          {
              "label": "cessão",
              "value": "cessão"
          },
          {
              "label": "concessão",
              "value": "concessão"
          },
          {
              "label": "licenciamento",
              "value": "licenciamento"
          },
          {
              "label": "licença",
              "value": "licença"
          },
          {
              "label": "autorização",
              "value": "autorização"
          },
          {
              "label": "prazo máximo",
              "value": "prazo máximo"
          },
          {
              "label": "território",
              "value": "território"
          },
          {
              "label": "objeto",
              "value": "objeto"
          },
          {
              "label": "modalidade de utilização",
              "value": "modalidade de utilização"
          },
          {
              "label": "onerosa",
              "value": "onerosa"
          },
          {
              "label": "gratuita",
              "value": "gratuita"
          }
      ]
  },
  {
      "label": "Comunicação ao público",
      "value": "Comunicação ao público",
      "children": [
          {
              "label": "ECAD",
              "value": "ECAD"
          },
          {
              "label": "escritório central",
              "value": "escritório central"
          },
          {
              "label": "associação",
              "value": "associação"
          },
          {
              "label": "gestão coletiva",
              "value": "gestão coletiva"
          },
          {
              "label": "prestação de contas",
              "value": "prestação de contas"
          },
          {
              "label": "arrecadação",
              "value": "arrecadação"
          },
          {
              "label": "distribuição",
              "value": "distribuição"
          },
          {
              "label": "representação",
              "value": "representação"
          },
          {
              "label": "empresário",
              "value": "empresário"
          },
          {
              "label": "execução pública",
              "value": "execução pública"
          },
          {
              "label": "frequência coletiva",
              "value": "frequência coletiva"
          },
          {
              "label": "teatros",
              "value": "teatros"
          },
          {
              "label": "cinemas",
              "value": "cinemas"
          },
          {
              "label": "salões de baile ou concertos",
              "value": "salões de baile ou concertos"
          },
          {
              "label": "concertos",
              "value": "concertos"
          },
          {
              "label": "boates",
              "value": "boates"
          },
          {
              "label": "bares",
              "value": "bares"
          },
          {
              "label": "clubes ou associações de qualquer natureza",
              "value": "clubes ou associações de qualquer natureza"
          },
          {
              "label": "lojas",
              "value": "lojas"
          },
          {
              "label": "estabelecimentos comerciais e industriais",
              "value": "estabelecimentos comerciais e industriais"
          },
          {
              "label": "estádios",
              "value": "estádios"
          },
          {
              "label": "circos",
              "value": "circos"
          },
          {
              "label": "feiras",
              "value": "feiras"
          },
          {
              "label": "restaurantes",
              "value": "restaurantes"
          },
          {
              "label": "hotéis",
              "value": "hotéis"
          },
          {
              "label": "motéis",
              "value": "motéis"
          },
          {
              "label": "clínicas",
              "value": "clínicas"
          },
          {
              "label": "hospitais",
              "value": "hospitais"
          },
          {
              "label": "órgãos públicos da administração direta ou indireta, fundacionais e estatais",
              "value": "órgãos públicos da administração direta ou indireta, fundacionais e estatais"
          },
          {
              "label": "meios de transporte de passageiros terrestre, marítimo, fluvial ou aéreo",
              "value": "meios de transporte de passageiros terrestre, marítimo, fluvial ou aéreo"
          }
      ]
  },
  {
      "label": "D. Penal e Processo Penal",
      "value": "D. Penal e Processo Penal"
  },
  {
      "label": "Sindicatos",
      "value": "Sindicatos"
  },
  {
      "label": "Direito do Trabalho",
      "value": "Direito do Trabalho"
  },
  {
      "label": "Direitos de Personalidade",
      "value": "Direitos de Personalidade"
  },
  {
      "label": "D. Processual Civil",
      "value": "D. Processual Civil"
  },
  {
      "label": "D. Tributário",
      "value": "D. Tributário"
  },
  {
      "label": "Propriedade Intelectual",
      "value": "Propriedade Intelectual"
  },
  {
      "label": "Responsabilidade Civil",
      "value": "Responsabilidade Civil"
  },
  {
      "label": "Prescrição",
      "value": "Prescrição"
  },
  {
      "label": "Processo civil",
      "value": "Processo civil"
  },
  {
      "label": "Processo penal",
      "value": "Processo penal"
  }
]

export {indices, mock};